import disableScroll from 'disable-scroll';

(function ($) {
    'use strict';

    const isMobile = 'ontouchstart' in document.documentElement

    const navigation = document.querySelector('.site-navigation')
    const hamburgerButton = document.querySelector('.site-navigation-button')

    setTimeout(() => {
        navigation.toggleAttribute('is-loading', false);
    }, 300)
    document.onscroll = e => {
        navigation.setAttribute('is-scrolling', window.scrollY > 0)
    }

    hamburgerButton.onpointerdown = e => {
        //toggle opened
        const opened = hamburgerButton.getAttribute('aria-expanded') == 'true'
        hamburgerButton.setAttribute('aria-expanded', !opened)
        navigation.setAttribute('aria-expanded', !opened)
        document.body.setAttribute('menu-expanded', !opened)
    }

    $('.menu-item-has-children > a').on('click', function() {
        if ($('.site-navigation').attr('aria-expanded') == 'true') {
            if ($('.menu-item-has-children').attr('submenu') == 'true') {
                $('#Hoofdmenu > .menu-item').show();
                $('.sub-menu').css('display', 'none');
                $('.menu-item-has-children').attr('submenu', 'false');
            } else {
                $('#Hoofdmenu > .menu-item').hide();
                $('.menu-item-has-children, .sub-menu').css('display', 'flex');
                $('.menu-item-has-children').attr('submenu', 'true');
            }}
    });



    var isHovered = false;

    if (window.matchMedia("(min-width: 1440px)").matches) {
        $(".sub-menu").addClass("card-container grid-col-4");

        $(".menu-item-has-children").hover(
            function () {
                $(this).addClass("hover");
                // isHovered = true;
                // disableScroll();
                disableScroll.on();
            },
            function () {
                $(this).removeClass("hover");
                // isHovered = false;
                // enableScroll();
                disableScroll.off();
            }
        );
    }

    // $(document).on('wheel', function(e) {
    //     preventScroll(e);
    // });

    // function preventScroll(e) {
    //     if (isHovered) {
    //         e.preventDefault();
    //         e.stopPropagation();
    //         console.log('Prevented scroll');
    //         return false;
    //     }
    // }

    // let scrollTop, scrollLeft;

    // function disableScroll() {
    //     // Get the current page scroll position
    //     scrollTop = window.pageYOffset || document.documentElement.scrollTop;
    //     scrollLeft = window.pageXOffset || document.documentElement.scrollLeft,
    //     console.log(scrollTop);
    //     console.log(scrollLeft);
    
    //         // if any scroll is attempted, set this to the previous value
    //         window.onscroll = function() {
    //             // window.scrollTo(scrollLeft, scrollTop);
    //             console.log('onscroll function');
    //             return false;
    //         };
    // }
    
    // function enableScroll() {
    //     window.onscroll = function() {};
    // }



    //Ajax call post post_type
    $(document).ready(function() {
        let currentPage = 1;
        $('#load-more').on('click', function() {
            currentPage++;
    
            $.ajax({
                type: 'POST',
                url: "/wp-admin/admin-ajax.php",
                dataType: 'json',
                data: {
                  action: 'babb_load_more',
                  paged: currentPage,
                },
                success: function (res) {
                    if(currentPage >= res.max) {
                        $('#load-more').addClass('hidden');
                    }
                    $('.post-grid').append(res.html);
                }
              });
        });
    });  
    //Ajax call overheid post_type
    $(document).ready(function() {
        let currentPage = 1;
        $('#load-more-overheid').on('click', function() {
            currentPage++;
    
            $.ajax({
                type: 'POST',
                url: "/wp-admin/admin-ajax.php",
                dataType: 'json',
                data: {
                  action: 'babb_load_more_overheid',
                  paged: currentPage,
                },
                success: function (res) {
                    if(currentPage >= res.max) {
                        $('#load-more-overheid').addClass('hidden');
                    }
                    $('.post-grid').append(res.html);
                }
              });
        });
    });   

    
})(jQuery);

function toggleDropdown() {
    document.getElementById("post-dropdown-content").classList.toggle("show");
}

window.onclick = function(event) {
    if (!event.target.matches('.post-dropdown-button')) {
        var dropdowns = document.getElementsByClassName("post-categories");
        var i;
        for (i = 0; i < dropdowns.length; i++) {
            var openDropdown = dropdowns[i];
            if (openDropdown.classList.contains('show')) {
            openDropdown.classList.remove('show');
            }
        }
    }
}